import React, { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import TransferRequestsStatusDropDowns from "../../Pages/Manager/TransferRequestsStatus/TransferRequestsStatusDropDowns";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReportStageTable from "../../Pages/Report/ReportStageTable";

function ReportStageRequest() {
  const [roundActive, setRoundActive] = useState(null);
  const [fields, setFields] = useState(null);
  const [flow, setFlow] = useState(null);
  const [ActionId, seActionId] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const arrayDataCheckBoks = useSelector(
  //   (state) => state.arrayDataCheckBoks?.arrayDataCheckBoks["tasksList"]
  // );

  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName="التقارير المرحلية"
        child={[
          <>
            <TransferRequestsStatusDropDowns
              setRoundActive={setRoundActive}
              setFields={setFields}
              // setFlow={setFlow}
              // seActionId={seActionId}
              manager="false"
            />
            <ReportStageTable
              roundActive={roundActive}
              fields={fields}
              // flow={flow}
            />
          </>,
        ]}
      />
      {/* <div className="containersButton">
        <div>
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              const missingFields = [];

              if (!roundActive) missingFields.push("الدورة");
              if (!fields) missingFields.push("الحقل");
              if (!flow) missingFields.push("المرحلة");
              if (!ActionId) missingFields.push("الإجراء");
              if (!arrayDataCheckBoks || arrayDataCheckBoks.length === 0)
                missingFields.push("الرجاء اختيار طلب واحد على الاقل");

              if (missingFields.length > 0) {
                Swal.fire({
                  icon: "warning",
                  title: "الرجاء تعبئة الحقول التالية",
                  html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${missingFields
                .map(
                  (field) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                )
                .join("")}
            </ul>
          </div>
        `,
                  confirmButtonText: "حسناً",
                  customClass: {
                    popup: "swal2-border-radius",
                  },
                });
                return;
              }
              navigate(
                `/SRFund/manager/ContainerTasks/${flow}/${ActionId}/${roundActive}/${fields}`
              );
            }}
            disabled={false}
            text={"اخذ الاجراء"}
            show={true}
          />
        </div>
      </div> */}
    </>
  );
}

export default ReportStageRequest;
